import React from 'react';
import { product } from '../data/content';
const links = [{
  label: product.email,
  href: `mailto:${product.email}`
}, {
  label: 'Instagram',
  href: '#'
}, {
  label: 'Official website',
  href: '#'
}];
export function Footer() {
  return <footer className="w-full bg-espresso py-14 text-cream" data-id="element-114" data-mp="32pp7k5pwm171">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-115" data-mp="36ooa5jo5xlvb">
        <p className="font-display text-2xl font-semibold" data-id="element-116" data-mp="36n3axgqwler4">The Braid &amp; Gloss Bible™</p>
        <p className="mt-3 font-sans text-base text-cream/70" data-id="element-117" data-mp="3ucxs2ai99ph6">
          The complete system for home-based hair professionals.
        </p>
        <p className="mx-auto mt-2 max-w-prose font-sans text-base text-cream/50" data-id="element-118" data-mp="3levkfc40nykx">
          Because building a hair business shouldn&rsquo;t cost you a cosmetology degree.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-119" data-mp="29zgkbzgigqll">
          {links.map(link => <li key={link.label} data-id="element-120" data-mp="2ezbb830adg6n">
              <a href={link.href} className="font-sans text-sm text-cream/70 transition-colors duration-150 ease-out hover:text-goldlight focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold" data-id="element-121" data-mp="2ezl0fodibjba">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 font-sans text-[11px] uppercase tracking-[0.14em] text-cream/40" data-id="element-122" data-mp="3q7ty7fo7a9v7">
          © The Braid &amp; Gloss Bible™ {new Date().getFullYear()} — All rights reserved.
        </p>
      </div>
    </footer>;
}